import React, { Component } from "react";
import Loader from "react-loader-spinner";
import auth from "../components/auth";
import { url } from "../components/url";
import bespoque from "../static/bespoque.jpeg";
import logo from "../static/rhmobile2.png";
import "./Login.css";

class Login extends Component {
  state = {
    login: "",
    password: "",
    isShowLoader: false,
  };

  componentDidMount() {
    if (localStorage.getItem("BRHMMobileToken") !== null) {
      auth.login(() => {
        // console.log(localStorage.getItem("MobileKgtin"));
        this.props.history.push("/home");
      });
    }
  }

  showLoader = (e) => {
    e.preventDefault();
    this.setState({ isShowLoader: true });
    setTimeout(() => {
      this.validateUser();
    }, 1000);
  };

  validateUser = () => {
    let formData = JSON.stringify({
      name: "generateToken",
      param: {
        login: this.state.login,
        pass: this.state.password,
      },
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        if (
          data.hasOwnProperty("response") &&
          data.response.result.hasOwnProperty("token")
        ) {
          auth.login(() => {
            localStorage.setItem("BRHMMobileToken", data.response.result.token);
          });
          this.props.history.push("/home");
        } else {
          this.setState({ isShowLoader: false });
          alert("Login or Password is Incorrect!");
        }
      })
      .catch((error) => {
        this.setState({ isShowLoader: false });

        if (error === "TypeError: Network request failed") {
          alert(
            "Something went wrong Kindly check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  placeUsername = (val) => {
    this.setState({
      login: val.target.value,
    });
  };

  placePassword = (val) => {
    this.setState({
      password: val.target.value,
    });
  };

  render() {
    return (
      <div>
        <form className="inputContainer" onSubmit={this.showLoader}>
          <div>
            <h3>Revenue House Manager Mobile</h3>
          </div>
          <div className="img">
            <img src={logo} className="imageStyle" alt="BRHM" />
          </div>
          <div className="login">
            <input
              type="text"
              name="name"
              onChange={this.placeUsername}
              className="input"
              placeholder="Login"
            />

            <input
              type="password"
              name="name"
              onChange={this.placePassword}
              placeholder="Password"
              className="input"
            />

            {this.state.isShowLoader ? (
              <div style={{ marginTop: 10 }}>
                <Loader type="Puff" color="#8cab49" height="40" width="40" />
              </div>
            ) : (
              <button className="button">Login</button>
            )}
          </div>

          <div className="bottomLogo">
            <p>Powererd By </p>
            <p>..... </p>
            <img src={bespoque} className="bespoque" alt="BBSL" />
          </div>
        </form>
      </div>
    );
  }
}

export default Login;
